export interface Config {
  endpoints: {
    status_api: string;
  };
  oidc: {
    authority: string;
    clientId: string;
    clientSecret: string;
    redirectUri: string;
    postLogoutRedirectUri: string;
    scope: string;
    responseType: string;
  };
  role: {
    siteAdmin: string;
  };
}

const scopes = "openid profile status:write";
const clientId = "hcss-status-ui";

const devAPI = "https://dev-hcss-status-api.azurewebsites.net";
const devUI = "https://hcssstatusdev.azureedge.net";

const devHccsAppsAPI = "https://dev-status-api.hcssapps.com";
const devHcssAppsUI = "https://dev-status.hcssapps.com";

const prodAPI = "https://prod-hcss-status-api.azurewebsites.net";
const prodUI = "https://hcssstatusprod.azureedge.net";

const prodHcssAppsAPI = "https://status-api.hcssapps.com"; 
const prodHcssAppsUI = "https://status.hcssapps.com";

const prodHcssUI = "https://status.hcss.com";

const devAdminRole = "HCSS ADMIN";
const prodAdminRole = "HCSS ADMIN";

const local: Config = {
  endpoints: {
    status_api: "https://localhost:51274",
  },
  oidc: {
    authority: "https://dev-identity.hcssapps.com",
    clientId: clientId,
    clientSecret: "dummy",
    redirectUri: "https://localhost:3000/oidc/signin-callback",
    postLogoutRedirectUri: "https://localhost:3000/",
    responseType: "code",
    scope: scopes,
  },
  role: {
    siteAdmin: devAdminRole,
  },
};

const dev: Config = {
  endpoints: {
    status_api: devAPI,
  },
  oidc: {
    authority: "https://dev-identity.hcssapps.com",
    clientId: clientId,
    clientSecret: "dummy",
    redirectUri: `${devUI}/oidc/signin-callback`,
    postLogoutRedirectUri: `${devUI}/`,
    responseType: "code",
    scope: scopes,
  },
  role: {
    siteAdmin: devAdminRole,
  },
};

const devHcssApps: Config = {
  endpoints: {
    status_api: devAPI,
  },
  oidc: {
    authority: "https://dev-identity.hcssapps.com",
    clientId: clientId,
    clientSecret: "dummy",
    redirectUri: `${devHcssAppsUI}/oidc/signin-callback`,
    postLogoutRedirectUri: `${devHcssAppsUI}/`,
    responseType: "code",
    scope: scopes,
  },
  role: {
    siteAdmin: devAdminRole,
  },
};

const production: Config = {
  endpoints: {
    status_api: prodAPI,
  },
  oidc: {
    authority: "https://identity.hcssapps.com",
    clientId: clientId,
    clientSecret: "dummy",
    redirectUri: `${prodUI}/oidc/signin-callback`,
    postLogoutRedirectUri: `${prodUI}/`,
    responseType: "code",
    scope: scopes,
  },
  role: {
    siteAdmin: prodAdminRole,
  },
};

const productionHcssApps: Config = {
  endpoints: {
    status_api: prodHcssAppsAPI,
  },
  oidc: {
    authority: "https://identity.hcssapps.com",
    clientId: clientId,
    clientSecret: "dummy",
    redirectUri: `${prodHcssAppsUI}/oidc/signin-callback`,
    postLogoutRedirectUri: `${prodHcssAppsUI}/`,
    responseType: "code",
    scope: scopes,
  },
  role: {
    siteAdmin: prodAdminRole,
  },
};

const productionHcss: Config = {
  endpoints: {
    status_api: prodHcssAppsAPI,
  },
  oidc: {
    authority: "https://identity.hcssapps.com",
    clientId: clientId,
    clientSecret: "dummy",
    redirectUri: `${prodHcssUI}/oidc/signin-callback`,
    postLogoutRedirectUri: `${prodHcssUI}/`,
    responseType: "code",
    scope: scopes,
  },
  role: {
    siteAdmin: prodAdminRole,
  },
};

export const GetEnvironmentConfig = () => {
  const hostname = window.location.hostname.toLowerCase();
  const origin = window.location.origin.toLowerCase();
  if (hostname.includes("localhost")) return local;
  if (hostname.includes("dev-status")) return devHcssApps;
  if (hostname.includes("hcssstatusdev")) return dev;
  if (origin.includes("https://status.hcssapps.com")) return productionHcssApps;
  if (origin.includes("https://dev-status.hcssapps.com")) return devHcssApps;
  if (origin.includes("https://status.hcss.com")) return productionHcss;
  if (hostname.includes("hcssstatusprod")) return production;
  return production;
};
